import Vue from 'vue';

Vue.component('language-page-links', {
    methods: {
        /**
         * Go to given URL with Geomate override cookie set.
         *
         * @param {String} url
         * @param {String} siteName
         */
        switchLanguage(url, siteName) {
            const expire = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);

            const europeOveride =
                siteName === 'default' ? 'mgMotorsEurope' : siteName;

            document.cookie = `RedirectOverride=${europeOveride}; expires=${expire.toUTCString()}; path=/`;

            const urlWithRedirectParam = new URL(url);
            const params = new URLSearchParams(urlWithRedirectParam.search);

            params.set('lang', europeOveride);
            urlWithRedirectParam.search = params.toString();
            // Move to URL
            document.location.href = urlWithRedirectParam.toString();
        },
    },
});
